/**
 * @generated SignedSource<<a4586c2b36fe71f9b55f118c4fdd6589>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfirmEmailAuthenticated_requestEmailVerification_Mutation$variables = {};
export type ConfirmEmailAuthenticated_requestEmailVerification_Mutation$data = {
  readonly requestEmailVerification: {
    readonly email: string;
  } | null;
};
export type ConfirmEmailAuthenticated_requestEmailVerification_Mutation = {
  response: ConfirmEmailAuthenticated_requestEmailVerification_Mutation$data;
  variables: ConfirmEmailAuthenticated_requestEmailVerification_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RequestEmailVerificationPayload",
    "kind": "LinkedField",
    "name": "requestEmailVerification",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConfirmEmailAuthenticated_requestEmailVerification_Mutation",
    "selections": (v0/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ConfirmEmailAuthenticated_requestEmailVerification_Mutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "76cfd686bfbc130636c9ef64bcf2ccb1",
    "id": null,
    "metadata": {},
    "name": "ConfirmEmailAuthenticated_requestEmailVerification_Mutation",
    "operationKind": "mutation",
    "text": "mutation ConfirmEmailAuthenticated_requestEmailVerification_Mutation {\n  requestEmailVerification {\n    email\n  }\n}\n"
  }
};
})();

(node as any).hash = "0882a6aeb7fd0eafe200b68222025882";

export default node;
